import { path, equals } from 'ramda';

export function checkIfEqualObjects<T>(oldValue: T, newValue: T): boolean {
  return equals(JSON.stringify(oldValue), JSON.stringify(newValue));
}
